"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Label = require("./shapes/Label");
var _Point = require("./shapes/Point");
var _Line = require("./shapes/Line");
var _Rectangle = require("./shapes/Rectangle");
var create = {
  label: _Label.createLabel,
  point: _Point.createPoint,
  line: _Line.createLine,
  rectangle: _Rectangle.createRectangle
};

// const shapes = { create, transform };
var _default = exports.default = create;